import { render } from "./LicenseDeliveryListView.vue?vue&type=template&id=6b378aa8&scoped=true"
import script from "./LicenseDeliveryListView.vue?vue&type=script&lang=js"
export * from "./LicenseDeliveryListView.vue?vue&type=script&lang=js"

import "./LicenseDeliveryListView.vue?vue&type=style&index=0&id=6b378aa8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b378aa8"]])

export default __exports__